
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination-practical-information-article/[destinationSlug]/[articleDocumentId]/[articleSlug]",
      function () {
        return require("private-next-pages/destination-practical-information-article/[destinationSlug]/[articleDocumentId]/[articleSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination-practical-information-article/[destinationSlug]/[articleDocumentId]/[articleSlug]"])
      });
    }
  